import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import './Nav.css'

const navVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.25, 0.1, 0.25, 1] },
  },
}

const linksVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08, delayChildren: 0.15 },
  },
}

const linkItem = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, ease: [0.25, 0.1, 0.25, 1] },
  },
}

const logoHoverTransition = {
  type: 'tween',
  duration: 0.28,
  ease: [0.25, 0.1, 0.25, 1],
}

export default function Nav() {
  const { pathname } = useLocation()
  const onHome = pathname === '/'
  const onStatePage = pathname.startsWith('/states/')

  return (
    <motion.nav className="nav" variants={navVariants} initial="hidden" animate="visible">
      <div className="nav-inner">
        <motion.div
          className="nav-logo-wrap"
          variants={linkItem}
          initial="hidden"
          animate="visible"
          whileHover={{ scale: 1.06, transition: logoHoverTransition }}
        >
          {onHome ? (
            <span className="nav-logo">State Route Markers</span>
          ) : (
            <Link to="/" className="nav-logo">
              State Route Markers
            </Link>
          )}
        </motion.div>

        <motion.ul className="nav-links" variants={linksVariants} initial="hidden" animate="visible">
          {onStatePage && (
            <motion.li variants={linkItem}>
              <Link to="/" className="nav-link-text">
                Back
              </Link>
            </motion.li>
          )}
          <motion.li variants={linkItem}>
            <Link to="/" className={`nav-link-text ${onHome ? 'active' : ''}`}>
              Overview
            </Link>
          </motion.li>
          <motion.li variants={linkItem}>
            <a href="/docs/notes/design-motivations.html" className="nav-link-text">
              Design Notes
            </a>
          </motion.li>
        </motion.ul>
      </div>
    </motion.nav>
  )
}
